import { makeRedirects } from "~/helpers/routes";

import { routes as app } from "~/router/routes/app";
import { routes as auth } from "~/router/routes/auth";
import { routes as settings } from "~/router/routes/settings";
import { routes as checkout } from "~/router/routes/checkout";
import { routes as ads } from "~/router/routes/ads";
import { routes as product } from "~/router/routes/product";
import { routes as blog } from "~/router/routes/blog";
import { routes as description } from "~/router/routes/description";
import { routes as backgroundRemover } from "~/router/routes/background-remover";
import { routes as backgroundGenerator } from "~/router/routes/background-generator";
import { routes as aiModelsPhotoshoot } from "~/router/routes/ai-models-photoshoot";
import { routes as watermarkRemover } from "~/router/routes/watermark-remover";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { routes as content } from "~/router/routes/content";
import { routes as photoEnhancer } from "~/router/routes/photo-enhancer";

export const routes = [
  ...app,
  ...auth,
  ...settings,
  ...(DISABLE_PAYMENTS ? [] : checkout),
  ...ads,
  ...product,
  ...blog,
  ...description,
  ...backgroundRemover,
  ...backgroundGenerator,
  ...watermarkRemover,
  ...makeRedirects(),
  ...content,
  ...aiModelsPhotoshoot,
  ...photoEnhancer,
];
